@if (!blank() && icon()) {
  <a
    class="social-icon"
    [class.social-icon--primary]="type() === 'primary'"
    [class.social-icon--secondary]="type() === 'secondary'"
    [class.social-icon--full]="type() === 'full'"
    [href]="link() ? link() : ''"
    target="_blank"
    [attr.aria-label]="icon()"
  ></a>
}
